module.exports = __webpack_public_path__ + "static/media/ico-realizadas.3d0015a8.svg";